import { Button, Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/next';

import { DecisionMakerCard } from '../DecisionMakerCard';
import { LegislativeBodyCard } from '../LegislativeBodyCard';

import { useViewAll } from './hooks/useViewAll';

export const ViewAll: React.FC = () => {
	const {
		data: { sortedAllDms, petitionAsk, viewAllText },
		actions: { trackViewAllDMsClick },
	} = useViewAll();

	return (
		<Modal
			size="large"
			onClose={() => {}}
			trigger={
				<div className="w-full text-center">
					<Button data-qa="legislative-bodies-show-all" className="w-full" onClick={trackViewAllDMsClick}>
						{viewAllText}
					</Button>
				</div>
			}
			className="z-[5000] lg:[&_*]:!col-span-full"
			data-qa="all-decision-makers-modal"
		>
			<ModalHeader title="All Decision Makers on this petition" subtitle={petitionAsk} />
			<ModalBody className="!max-h-none">
				{sortedAllDms.map((block) =>
					block.component === 'primary' || block.component === 'individual' ? (
						<DecisionMakerCard key={block.componentDm.id} dm={block.componentDm} />
					) : (
						<LegislativeBodyCard
							key={block.componentAttributes.title}
							legislativeBody={{
								...block.componentAttributes,
								allDMs: block.componentDms,
								displayedDMs: block.componentDms,
								viewMoreText: undefined,
							}}
						/>
					),
				)}
			</ModalBody>
		</Modal>
	);
};
